export const RED = '#832120'
export const FOND_GREEN = '#f6f8f2'